// extracted by mini-css-extract-plugin
module.exports = {"emoItem":"emoItem___23o_O","emo":"emo___YreRV","tooltip":"tooltip___3W6hl"};